<template>
  <div :class="['w3-row', 'definition-wrapper', 'file', definition.id, {'error_validate': mandatoryValidation}]">
    <div class="file">
      <transition name="fade" mode="out-in">
        <div v-if="fileValue === '' && ((isMultiLanguage() && showMultilanguage) || (definition.task && definition.task.length > 0 && editable))" :class="['w3-rest', 'tiny-rest', 'languageSelectorOrTask', {'no_file' : fileValue === ''}]">
          <definition-multilanguage v-if="isMultiLanguage() && showMultilanguage"
            :definition="definition" :object="object" :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
            @newLanguageSelected="newLanguageSelected" @copy="copy"
          />
          <definition-task
            v-if="definition.task && definition.task.length > 0 && editable"
            :definition="definition"
            :object="object"
            :definitionObject="definitionObject"
            :definitionContentId="definitionContentId"
            :repeatableGroupCode="getfileCode()"
            :languageSelected='languageSelected'
            :language="language"
            :authorization="authorization"
            :type="type"
            :visuals="visuals"
            :apiparams="apiparams"
            :callTask="callTask"
            @refreshDefinition="taskValueChanged"
            @refreshDefinitionContent="refreshDefinitionContent"
          />
        </div>
      </transition>
      <div :class="['w3-col', 'file', {'languagefile': (isMultiLanguage() && showMultilanguage) || (definition.task && definition.task.length > 0 && editable)}]">
        <transition name="fade" mode="out-in">
          <div v-if="fileValue !== ''" class="file-link">
            <a :href="fileValue" target="_blank">{{ fileName }} <i class="fas fa-external-link-alt"></i></a>
            <i v-if="editable" class="sherpa-icon icon-trash" @click="clearFile"></i>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionMultilanguage from './multilanguage'
import DefinitionTask from './task'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
import language from '../language'

export default {
  name: 'definition-file',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'showMultilanguage',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'callTask'
  ],
  components: {
    DefinitionReadOnly,
    DefinitionMultilanguage,
    DefinitionTask
  },
  data () {
    return {
      fileValue: '',
      translating: false
    }
  },
  methods: {
    // 1.1. Launch validate mandatory event on change
    taskValueChanged (object) {
      if (this.isMultiLanguage()) {
        this.fileValue = transport.methods.getLanguageValue(object, this.languageSelected.key)
      } else {
        this.fileValue = object.textValue
      }
      this.setObjectfileValue(object)
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    setfileValue (languageSelected) {
      if (!this.isMultiLanguage()) {
        if (this.object.textValue) {
          this.fileValue = this.object.textValue
        } else {
          this.fileValue = ''
        }
      } else if (languageSelected) {
        this.setLanguagefileValue(languageSelected)
      }
    },
    setLanguagefileValue (languageSelected) {
      this.fileValue = transport.methods.getLanguageValue(this.object, languageSelected.key)
    },
    validateFileFormat () {
      var format = null
      if (this.isMultiLanguage()) {
        format = transport.methods.getLanguage(this.languageSelected.key, this.definition).format
      } else {
        format = this.definition.validation.format
      }
      this.validation = transport.methods.validateFileFormat(this.definition, format, this.fileValue)
      // 3. if text format validation past...
      if (this.validation === null) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      } else {
        // ... or launch text format error event to show error message
        this.$emit('fileFormatError', moment().valueOf(), this.validation, format)
      }
    },
    isMultiLanguage () {
      return transport.methods.isMultiLanguage(this.definition)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    setObjectfileValue (object) {
      if (this.isMultiLanguage()) {
        if (object) {
          this.object.languageValue = object.languageValue
        }
        this.object = transport.methods.setLanguageValue(this.object, this.fileValue, this.languageSelected.key)
      } else {
        this.object.textValue = this.fileValue
      }
    },
    getLang (key) {
      return language(this.language, key)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    copy (fromLanguage) {
      if (this.fileValue.trim() !== '' && this.isMultiLanguage() && this.object.languageValue && this.object.languageValue.length > 1) {
        this.translating = true
        var self = this
        setTimeout(function () {
          self.copyLanguage(fromLanguage, 0, self.object.languageValue)
        }, 500)
      }
    },
    copyLanguage (fromLanguage, index, languages) {
      if (index < languages.length) {
        var language = this.object.languageValue[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          this.object = transport.methods.setLanguageValue(this.object, this.fileValue, language.key)
        }
        this.copyLanguage(fromLanguage, ++index, languages)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
          self.$emit('validateMandatory', moment().valueOf(), self.object)
        }, 200)
      }
    },
    getfileCode () {
      var result = this.repeatableGroupCode
      if (!result) {
        var authVars = this.authorization.split(' ')
        // Segon paràmetre del bearer token "-" timestamp
        var sha256 = require('js-sha256')
        result = sha256(authVars[1] + '-' + moment().valueOf())
        this.$emit('refreshRepeatableGroupCode', result)
      }
      return result
    },
    clearFile () {
      this.fileValue = ''
      this.setObjectfileValue(this.object)
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    }
  },
  mounted () {
    this.setfileValue(this.languageSelected)
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch file format validation
        this.validateFileFormat()
      }
    },
    languageSelected (languageSelected) {
      if (this.isMultiLanguage()) {
        this.setLanguagefileValue(languageSelected)
      }
    },
    object (object) {
      this.setfileValue(this.languageSelected)
    }
  },
  computed: {
    fileName () {
      var result = ''

      if (this.fileValue && this.fileValue !== '') {
        // result = this.fileValue.substring(this.fileValue.lastIndexOf('/') + 1)
        result = this.getLang('linkFileClick')
      }

      return result
    }
  }
}
</script>

<style lang="scss">
  .languagefile {
    float: left;
    width: calc(100% - 110px);
    overflow: hidden;
    border-radius: 5px;
    text-align: left;

    img {
      max-width: 100%;
    }
  }

  .definition-wrapper.file {
    .languageSelectorOrTask {
      float: left;
      min-width: 108px;

      .language {
        max-width: 151px;
        margin-bottom: 10px;

        .multiselect {
          float: left;
          width: auto;

          .multiselect__tags {
            width: 105px;
          }

          .multiselect__tags,
          .multiselect__single,
          .multiselect__input {
            background-color: #efefef;
          }
        }
      }

      #uploadFile {
        width: 100%;
        border-top: 1px dashed #ffbf28;

        .dz-message {
          p {
            margin: 0;
          }
          i {
            top: 8px !important;
            font-size: 30px !important;
            display: inline-block;
            font-size: inherit;
            text-rendering: auto;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
          span {
            span {
              top: 50px !important;
            }
          }
        }
      }
    }
    .file {
      img {
        width: 100%;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .no_file {
    position: relative;

    i {
      position: absolute;
      top: 45px;
      right: 0;
      left: 0;
      text-align: center;
      font-size: 2.5em;
      color: #cfcfcf;
    }

    span {
      font-size: 14px;
      color: #afafaf;
      font-family: "Source Sans Pro", sans-serif;
      text-align: center;
      font-weight: 400;
      padding: 0 2px;
      font-style: italic;
    }
  }
  .file-link {
    color: #5dbecb;
    margin-top: 10px;
    font-size: 14px;
    font-family: "Source Sans Pro", sans-serif;

    a {
      transition: all 0.2s ease-in;
      opacity: 0.9;

      &:hover {
        opacity: 1;
      }
    }

    i {
      margin-left: 5px;
      opacity: 0.9;
      cursor: pointer;
      transition: all 0.2s ease-in;
      vertical-align: text-top;
      margin-top: 3px;

      &:hover {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/file.vue